import { useQuery } from '@tanstack/react-query'

import { api } from '@/lib/api'
import { queryKeys } from '@/lib/query'
import { MOCK_SESSION, USE_MOCKS } from '@/mocks/fixtures'
import type { CurrentUser } from '@/types/domain'

/* The session is server-side: an opaque token in an httpOnly cookie (AD-21).
 * There is nothing to read from JS — we ask the server who we are, and a 401
 * means "not signed in". Role arrives from the server and shapes navigation as
 * an affordance only; the API is the sole enforcement. */

export function useSession() {
  return useQuery<CurrentUser>({
    queryKey: queryKeys.session,
    queryFn: () =>
      USE_MOCKS
        ? Promise.resolve(MOCK_SESSION)
        : api.get<CurrentUser>('/session'),
    // A signed-out user is not an error condition worth retrying.
    retry: false,
    staleTime: 5 * 60_000,
  })
}
